import React from 'react';
import classnames from 'classnames';
import modifiers from '../../modifiers';
import Element from '../../element';
import Brand from './brand';
import Menu from './menu';
import Item from './item';
import Dropdown from './dropdown';
import Link from './link';
import Container from './container';
import { PREFIX } from '@zmedia/bm-soccer-ui/constants';
import styles from './navbar.module.scss';

interface IProps {
    className?: string;
    children: React.ReactNode;
    fixed?: string;
    transparent?: string;
    color?: string;
    active?: string;
}

function Navbar(props: IProps) {
    const {
        children,
        className,
        fixed,
        transparent,
        color,
        active,
        ...rest
    } = props;

    return (
        <Element
            renderAs="nav"
            className={classnames(
                styles[`${PREFIX}-navbar`],
                modifiers.classnames(props),
                className,
                {
                    'is-transparent': transparent,
                    [`is-fixed-${fixed}`]: fixed,
                    [`is-${color}`]: color,
                }
            )}
            {...rest}
        >
            {children}
        </Element>
    );
}

Navbar.Brand = Brand;
Navbar.Menu = Menu;
Navbar.Item = Item;
Navbar.Link = Link;
Navbar.Dropdown = Dropdown;
Navbar.Container = Container;

export default Navbar;
